import Image from 'next/image';
import Link from 'next/link';
import { INTOWhiteLogo } from '../../atoms/icons/icons';
import styles from './top-menu.module.scss';

export type LogoProps = {
  invertedTheme: boolean;
  currentLocale: string;
  brandLogo: string;
  brandLogoAltText: string;
  isBreakpointUp: boolean;
  isLarger: boolean;
};

type ImageDimensions = {
  width: number;
  height: number;
};

const dimensions: Record<string, ImageDimensions> = {
  large: { width: 361, height: 104 },
  medium: { width: 260, height: 48 },
  small: { width: 230, height: 40 },
};

export function Logo({
  invertedTheme,
  currentLocale,
  brandLogo,
  brandLogoAltText,
  isBreakpointUp,
  isLarger,
}: LogoProps) {
  let dimension: ImageDimensions;
  if (isBreakpointUp && isLarger) {
    dimension = dimensions.large;
  } else if (isBreakpointUp && !isLarger) {
    dimension = dimensions.medium;
  } else {
    dimension = dimensions.small;
  }

  return (
    <Link
      className={`image-wrapper me-md-5 ${styles['header-top_logo']} ${invertedTheme ? styles['inverted-theme'] : ''}`}
      href={`/${currentLocale}`}
    >
      {brandLogo ? (
        <Image
          src={brandLogo}
          alt={brandLogoAltText}
          width={dimension.width}
          height={dimension.height}
        />
      ) : (
        <INTOWhiteLogo />
      )}
    </Link>
  );
}
